import type { GeoWatcher } from '../core/GeoWatcher';
import type { OrientationSource } from '../core/OrientationSource';

/**
 * デバッグHUD(計画書F-6)。lat/lon/accuracy/heading/fps/モードを表示。
 * `?debug=1` で有効化。
 */
export class DebugHud {
  private root: HTMLElement;
  private frames = 0;
  private fps = 0;
  private lastFpsTime = performance.now();
  private extra = '';

  constructor(
    container: HTMLElement,
    private geo: GeoWatcher | null,
    private orientation: OrientationSource | null,
    private mode: string,
  ) {
    this.root = document.createElement('div');
    this.root.className = 'debug-hud';
    container.appendChild(this.root);
    setInterval(() => this.refresh(), 250);
  }

  setMode(mode: string): void {
    this.mode = mode;
  }

  /** 毎フレーム呼ぶ(fps計測) */
  tick(): void {
    this.frames++;
    const now = performance.now();
    if (now - this.lastFpsTime >= 1000) {
      this.fps = (this.frames * 1000) / (now - this.lastFpsTime);
      this.frames = 0;
      this.lastFpsTime = now;
    }
  }

  setExtra(text: string): void {
    this.extra = text;
  }

  private refresh(): void {
    const s = this.geo?.current;
    const raw = this.geo?.raw;
    const heading = this.orientation?.magneticHeadingDeg;
    const lines = [
      `mode: ${this.mode}   fps: ${this.fps.toFixed(0)}`,
      s
        ? `lat: ${s.lat.toFixed(6)}  lon: ${s.lon.toFixed(6)}`
        : 'gps: 取得待ち…',
      s ? `enu: E ${s.east.toFixed(1)}m  N ${s.north.toFixed(1)}m` : '',
      raw ? `acc: ${raw.accuracy.toFixed(1)}m ${raw.accuracy > 25 ? '(棄却中)' : ''}` : '',
      heading !== null && heading !== undefined
        ? `heading(mag): ${heading.toFixed(1)}° ${this.orientation?.isAbsolute ? '(絶対)' : '(相対=要キャリブレーション)'}`
        : 'heading: 取得待ち…',
      this.extra,
    ].filter((l) => l !== '');
    this.root.textContent = lines.join('\n');
  }

  destroy(): void {
    this.root.remove();
  }
}
